import { useCallback, useState } from "react";
import Spinner from "../spinner";

export default function NeutralButton({
  text,
  onClick,
}: {
  text: string;
  onClick: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      setLoading(true);
      try {
        await onClick();
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    },
    [setLoading, onClick]
  );

  return (
    <button
      disabled={loading}
      className="block w-full rounded-md border border-solid border-gray-300 active:bg-gray-50 text-sm text-gray-700 hover:bg-gray-50 px-5 pt-2 pb-2.5 shadow-sm"
      onClick={handleClick}
    >
      <div className="flex justify-center items-center">
        {loading ? (
          <Spinner className="mr-2.5 fill-black w-5 h-5"></Spinner>
        ) : null}
        {text}
      </div>
    </button>
  );
}
